"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createObjectSchemaComponent = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const core_1 = require("react-hook-schema/core");
const hooks_1 = require("common/hooks");
const Property = ({ fieldPath, readOnly, control, property, selector: Field, }) => {
    console.log("selector", Field);
    const { title, propertyName, schema, noLabel, tooltip, tooltipVariant, style, } = property;
    const s = (0, hooks_1.useStringIntl)();
    const { formatMessage } = (0, hooks_1.useFormatter)();
    const content = (react_1.default.createElement(Field, { control: control, fieldPath: (0, core_1.joinFieldPath)(fieldPath, propertyName), readOnly: readOnly, schema: schema, label: s(title) }));
    if (noLabel) {
        return content;
    }
    else
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)("field-pair", property.stacked && "stacked-form"), style: Object.assign({ gridColumn: "span 12" }, style), key: 0 },
            react_1.default.createElement("div", { className: "field-label" },
                react_1.default.createElement("label", { className: "label" },
                    react_1.default.createElement("span", { style: {
                            verticalAlign: "middle",
                            whiteSpace: "nowrap",
                        } }, s(title)),
                    schema.required && !readOnly && !schema.readOnly && (react_1.default.createElement("span", { style: {
                            marginLeft: "4px",
                            verticalAlign: "middle",
                            padding: "1px 6px",
                            color: "#4E4C5A",
                            fontSize: "8px",
                            fontWeight: 700,
                            borderRadius: "6px",
                            whiteSpace: "nowrap",
                            backgroundColor: "#FACC15",
                        } }, formatMessage("Field.Required"))),
                    tooltip && (react_1.default.createElement(react_1.default.Fragment, null, tooltipVariant === "fixed" ? (react_1.default.createElement("p", { className: "text-secondary", style: { fontWeight: "normal", fontSize: "14px" } }, tooltip)) : (react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", "data-tooltip-id": "tooltip", "data-tooltip-html": true && `<div class="tooltip-content">${tooltip}</div>`, style: {
                            borderRadius: "50%",
                            width: "16px",
                            height: "16px",
                            padding: "0",
                            flexShrink: 0,
                        } },
                        react_1.default.createElement("span", { className: "mdi mdi-information-variant size10" }))))))),
            react_1.default.createElement("div", { className: "field-content" }, content)));
};
const createObjectSchemaComponent = (selectorGenerator) => (({ fieldPath, readOnly, control, schema, label, }) => {
    const { properties, uiType, style } = schema;
    // if (uiType === "dialog") {
    //   const modalForm = useModalForm();
    //   const { value, registerProps } = useField(
    //     { fieldPath, control, schema, label },
    //     [],
    //   );
    //   return (
    //     <InputGroup>
    //       <div style={{ flex: "1", alignSelf: "center" }}>
    //         <Field
    //           schema={properties[0].schema}
    //           fieldPath={joinFieldPath(fieldPath, properties[0].propertyName)}
    //           control={control}
    //           label={label}
    //           readOnly={true}
    //         />
    //       </div>
    //       <Button
    //         variant="outline-secondary"
    //         onClick={async () => {
    //           const newValue = await modalForm({
    //             params: {
    //               schema: { ...schema, uiType: undefined },
    //               title: label,
    //             },
    //             value,
    //           });
    //           if (newValue) {
    //             registerProps.onChange(newValue);
    //           }
    //         }}
    //       >
    //         <i className="mdi mdi-pencil" />
    //       </Button>
    //     </InputGroup>
    //   );
    // }
    return (react_1.default.createElement("div", { style: style }, properties === null || properties === void 0 ? void 0 : properties.filter(({ disabled }) => !disabled).map((property, index) => (react_1.default.createElement(Property, { selector: selectorGenerator(), schema: property.schema, control: control, readOnly: readOnly, fieldPath: fieldPath, key: String(property.propertyId || property.propertyName), property: property })))));
});
exports.createObjectSchemaComponent = createObjectSchemaComponent;
